import {
  Status,
  StatusValue,
  OfferKind,
  FulfillmentMethod,
  Weekday,
} from '../../store/offers/types';

export const PAGINATION_DEFAULT = 1;
export const PAGINATION_PER_PAGE = 6;

export const DAYS_OF_WEEK = Weekday;

export const PROGRESS_STEP_NONE = -1;
export const PROGRESS_STEP_CREATE = 0;
export const PROGRESS_STEP_REVIEW = 1;
export const PROGRESS_STEP_KEYS = ['details', 'review'];

export const OFFER_STATE_SCHEDULED: StatusValue = Status.SCHEDULED;
export const OFFER_STATE_LIVE: StatusValue = Status.LIVE;
export const OFFER_STATE_ENDED: StatusValue = Status.ENDED;
export const OFFER_STATE_CANCELLED: StatusValue = Status.CANCELLED;
export const OFFER_CANCELABLE_STATES = [
  OFFER_STATE_LIVE,
  OFFER_STATE_SCHEDULED,
];
export const OFFER_STATES: StatusValue[] = [
  OFFER_STATE_SCHEDULED,
  OFFER_STATE_LIVE,
  OFFER_STATE_ENDED,
  OFFER_STATE_CANCELLED,
];

// TODO(jlo): replace the client-side statuses above with these.
export const OFFER_API_STATE_ACTIVE = 'active';
export const OFFER_API_STATES = ['active', 'scheduled', 'expired', 'cancelled'];

export const START_DATE_OFFSET_DAYS = 3;
export const REPORT_LEAD_TIME_DAYS = 7;

// This is temporary; we will have a full T&Cs page at a later stage.
export const TERMS_AND_CONDITIONS_URL =
  'https://docs.google.com/document/d/1GqETRujnbpCe4NFu4uYhcL6NJIFhepstRzWOR8lQvI8/edit?usp=sharing';

export const OFFER_DURATIONS = [1, 3, 5, 7, 14];
export const OFFER_START_HOUR = 9;

export const OFFER_FULFILLMENT_METHOD_DELIVERY = FulfillmentMethod.DELIVERY;
export const OFFER_FULFILLMENT_METHOD_PICKUP = FulfillmentMethod.COLLECTION;
export const OFFER_FULFILLMENT_METHOD_DINE_IN = FulfillmentMethod.DINE_IN;
export const OFFER_FULFILLMENT_METHODS = [
  OFFER_FULFILLMENT_METHOD_DELIVERY,
  OFFER_FULFILLMENT_METHOD_PICKUP,
  OFFER_FULFILLMENT_METHOD_DINE_IN,
];

export const OFFER_TYPES = OfferKind;
